// extracted by mini-css-extract-plugin
export var arrowIcon = "BoleronEuBanner-module--arrowIcon--e2f64";
export var banner = "BoleronEuBanner-module--banner--b2a2d";
export var description = "BoleronEuBanner-module--description--42705";
export var left = "BoleronEuBanner-module--left--acd6a";
export var link = "BoleronEuBanner-module--link--ee5b7";
export var separator = "BoleronEuBanner-module--separator--1e47c";
export var title = "BoleronEuBanner-module--title--7f13e";